// "Where this comes from": the publishers behind a piece of advice, linked,
// and a tag for numbers worked out from his own logs.

import { ExternalLink } from 'lucide-react';
import { publisher } from '../content/sources.ts';
import type { SourceRef } from '../content/types.ts';

export function SourceList({ refs, label = 'Sources' }: { refs?: SourceRef[]; label?: string }) {
  if (!refs?.length) return null;
  // "Dogs Trust · Dogs Trust" says nothing: when a publisher repeats, show the page title.
  const pubs = refs.map(publisher);
  const name = (s: SourceRef, i: number) => (pubs.indexOf(pubs[i]) !== pubs.lastIndexOf(pubs[i]) ? s.label : pubs[i]);
  return (
    <p className="source-list small">
      <span className="muted">{label}:</span>{' '}
      {refs.map((s, i) => (
        <span key={s.url}>
          {i > 0 && ' · '}
          <a href={s.url} target="_blank" rel="noreferrer" className="link" title={s.label}>
            {name(s, i)}
            <ExternalLink aria-hidden className="inline-icon" />
          </a>
        </span>
      ))}
    </p>
  );
}

/** Which data a figure is from: his logs, the camera, the plan… */
export function FromTag({ from }: { from: string }) {
  return <span className="from-tag">{from}</span>;
}
